import Vue from 'vue'
import Vuex from 'vuex'
import {FirebaseSingleton} from "../helpers/firebaseSingleton"
import firebaseApp from './firebaseVuex.js'



Vue.use(Vuex)



export default new Vuex.Store({
  modules:{
    FirebaseApp:firebaseApp
  },
  state: {
    typePaid: 0,
    mdnSelected:'',
    priceSelected:0,
    globalPrice:0,
    urlPrefix:'',
    codeRequested:false,
    useVK:false,
    selectedPlayers:[],
    productReservas:[],
    selectedExtraRider:[],
    mainClient:{},
    ProductosGlobal:[],
    OrigenesCaja:[],
    Mayoristas:[],
    CentrosConsumo:[],
    Departamentos:[],
    idDepartamentos:[],
    rva_catalogo:[],
    selectedReserva:[],
    selectedAccount:[],
    pdvDepartamentos:[],
    tiposCambio:{},
    clientes:[],
  },
  getters: {
    getFirebaseApp:state=>{
      return state.FirebaseApp.firebaseApp;
    },
    getMndSelected:state=>{
      return state.mdnSelected;
    },
    getClientes:state=>{
      return state.clientes;
    },
    getTiposCambios:state=>{
      return state.tiposCambio;
    },
    getPDVDepartamentos:state=>{
      return state.pdvDepartamentos;
    },
    getUseVK:state=>{
      return state.useVK;
    },
    getSelectedAccount:state=>{
      return state.selectedAccount;
    },
    getRVACatalogo:state=>{
      return state.rva_catalogo;
    },
    getIdDepartamentos:state=>{
      return state.idDepartamentos;
    },
    getDepartamentos:state=>{
      return state.Departamentos;
    },
    getCentrosConsumo:state=>{
      return state.CentrosConsumo;
    },
    getMayoristas:state=>{
      return state.Mayoristas;
    },
    getOrigenes:state=>{
      return state.OrigenesCaja;
    },
    getProductos: state =>{
      return state.ProductosGlobal;
    },
    getMainClient: state => {
      return state.mainClient;
    },
    getSelectedRiders: state => {
      return state.selectedExtraRider;
    },
    getSelectedPlayer: state => {
      return state.selectedPlayers;
    },
    getproductReservas: state => {
      return state.productReservas;
    },
    getTypePaid: state => {
      return state.typePaid;
    },
    getPriceSelected: state => {
        return state.priceSelected;
    },
    getGlobalPrice: state => {
      return state.globalPrice;
    },
    getUrlPrefix: state => {
      return state.urlPrefix;
    },
    getCodeRequested: state =>{
      return state.codeRequested;
    }
  },
  mutations: {
    setMndSelected(state,value){
      state.mdnSelected = value;
    },
    setTiposCambio(state,value){
      state.tiposCambio = value;
    },
    setPDVDepartamentos(state,value){
      state.pdvDepartamentos = value;
    },
    setClientes(state,value){
      state.clientes = value;
    },
    setUseVK(state,value){
      state.useVK=value;
    },
    addSelectedAccount(state,value){
      state.selectedAccount.push(value);
    },
    editSelectedAccountItem(state,value){
      state.selectedAccount[value.productoId] = value;
    },
    replaceSelectedAccount(state,value){
      state.selectedAccount = value
    },
    resetSelectedAccount(state){
      state.selectedAccount = [];
    },
    setRVACatalogo(state,value){
      state.rva_catalogo=value;
    },
    setIdDepartamentos(state,value){
      state.idDepartamentos=value;
    },
    setDepartamentos(state,value){
      state.Departamentos = value
    },
    setCentrosConsumo(state,value){
      state.CentrosConsumo = value;
    },
    setMayoristas(state,value){
      state.Mayoristas = value;
    },
    setOrigenes(state,value){
      state.OrigenesCaja = value;
    },
    setProductos(state,value){
      state.ProductosGlobal = value;
    },
    setMainClient(state,value){
      state.mainClient = value;
    },
    resetMainClient(state){
      state.mainClient = {};
    },
    setCodeRequested(state,value){
      state.codeRequested = value;
    },
    addSelectedPlayer (state,value) {
      state.selectedPlayers.push(value);
    },
    addSelectedRider (state,value) {
      state.selectedExtraRider.push(value);
    },
    addproductReservas (state,value) {
      state.productReservas.push(value);
    },
    removeSelectedPlayer(state,value){
        state.selectedPlayers.splice(value, 1);
    },
    editPlayer(state,value){
      let item = state.productReservas[value.idx];
      item.OriginalPrice = value.datos.Precio;
      item.Precio  = value.datos.precioPeso;
      item.Pco     =  value.datos.Precio
      item.Mnd     = value.datos.Moneda
      state.productReservas[value.idx] = item;

    },
    removeSelectedRider(state,value){
      state.selectedExtraRider.splice(value, 1);
    },
    replaceAllproductReservas(state,value){
      state.productReservas = value
    },
    resetSelectedRiders(state){
      state.selectedExtraRider = [];
    },
    resetSelectedPlayer(state){
      state.selectedPlayers = [];
    },
    resetproductReservas(state){
      state.productReservas = [];
    },
    setTypePaid (state,value) {
        state.typePaid = value;
    },
    setUrlPrefix (state,value) {
      state.urlPrefix = value;
    },
    setPriceSelected (state,value) {
        state.priceSelected = value;
    },
    setGlobalPrice (state,value) {
      state.globalPrice = value;
    }
  },
  actions: {
    listenerTiposCambio:async (context)=>{
        const appFirebase = await FirebaseSingleton.init()
          var data =  appFirebase.firestore.collection("PDV_TipoCambio").where("Tenant","==",context.rootState.FirebaseApp.firebaseApp.tenant).orderBy('FechaCreacion','desc').limit(1).onSnapshot((querySnapshot) => {
            let prod = [];
            querySnapshot.forEach((doc) =>{
                prod.push({id:doc.ref.id,...doc.data()});
            });
            let tiposCambio = querySnapshot.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}});
            context.commit('setTiposCambio', tiposCambio);
          });
    },
    async listenerProducts(context) {
        const appFirebase = await FirebaseSingleton.init()
        var data =  appFirebase.firestore.collection("PDV_Productos").where("Tenant","==",context.rootState.FirebaseApp.firebaseApp.tenant).onSnapshot((querySnapshot) => {
              let prod = [];
              querySnapshot.forEach((doc) =>{
                  prod.push({id:doc.ref.id,...doc.data()});
              });
              context.commit('setProductos', prod);
        });
    },
    async listenerClientes(context) {
      const appFirebase = await FirebaseSingleton.init()
      var data =  appFirebase.firestore.collection("PDV_Clientes").where("Tenant","==",context.rootState.FirebaseApp.firebaseApp.tenant).onSnapshot((querySnapshot) => {
            let prod = [];
            querySnapshot.forEach((doc) =>{
                prod.push({id:doc.ref.id,...doc.data()});
            });
            context.commit('setClientes', prod);
      });
    },
    listenerInventarios:async(context,vueApp)=>{
      const appFirebase = await FirebaseSingleton.init()
      let config = vueApp.$uvHelper.readConfig();
      const dataCaja          = await appFirebase.database.ref("PDV/Cajas/"+config.caja_id+"").once("value");
      let result              = dataCaja.val();
      if(!result){
        return false;
      }

      var data =  appFirebase.firestore.collection("PDV_Inventario").where('Origen','in',result.Origenes)
        .onSnapshot((querySnapshot) => {
            let origenes = [];
            querySnapshot.forEach((doc) =>{
                 //let itemIndex = this.$_.findIndex(origenesNames,{ 'id': doc.data().Origen});
                origenes.push({id:doc.ref.id,...doc.data()});
            });
             //console.log(origenes);
            // console.log('detectando cambio, aplicando listener');
            context.commit('setOrigenes', origenes);
        });
    },
    listenerInventariosWeb:async(context,vueApp)=>{
        const appFirebase = await FirebaseSingleton.init()
        var dataOrigen =  await appFirebase.database.ref("PDV/Inventario/Origenes").once("value");

        if(!dataOrigen.exists()){
          return false;
        }

        let arrayOrg      = Object.entries(dataOrigen.val()); 
        let origenesNames = [];
        arrayOrg.forEach(function(element){
          origenesNames.push({id:element[0],Nombre:element[1]['Nombre'],Departamentos:element[1]['Departamentos']}); 
        });


      var data =  appFirebase.firestore.collection("PDV_Inventario")
      .onSnapshot((querySnapshot) => {
          let origenes = [];
          querySnapshot.forEach((doc) =>{
                let itemIndex = vueApp.$_.findIndex(origenesNames,{ 'id': doc.data().Origen});
              origenes.push({id:doc.ref.id,nombreOrigen:origenesNames[itemIndex].Nombre,...doc.data()});
          });
            context.commit('setOrigenes', origenes);
      });

    }
  },

})
